import { CaretRightFilled } from "@ant-design/icons";
import { Button } from "antd";
import { FormattedMessage } from "react-intl";
import { useState } from "react";
import { PreCaptureInformationDialog } from "./PreCaptureInformationDialog";

export function StartCapture() {
  const [open, setOpen] = useState(false);

  return (
    <div>
      <Button
        className="rounded-full bg-primary px-6 text-white shadow-none items-center text-center"
        icon={<CaretRightFilled />}
        onClick={() => setOpen(true)}
        type="primary"
      >
        <FormattedMessage id="topbar.tryCapture" />
      </Button>
      <PreCaptureInformationDialog
        open={open}
        onCancel={() => setOpen(false)}
      />
    </div>
  );
}
